/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { HospVaccChart } from 'components/hospVaccChart'
import { DeathVaccTable } from 'components/deathVaccTable'
import BrkthruBarChart from 'components/BrkthruBarChart'
import { UpdateNote } from '@ta-interaktiv/contentbricks'

// GET PARAMS FROM URL
const params = new URL(window.location).searchParams
const display = params.get('display')

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />

      {(display === 'hosp' || (display !== 'death' && display !== 'type')) && (
        <>
          {/* <UpdateNote updating='Wird um 14 Uhr aktualisiert, ausser am Wochenende' /> */}
          <HospVaccChart />
        </>
      )}

      {display === 'death' && (
        <>
          {/* <UpdateNote updating='Wird um 14 Uhr aktualisiert, ausser am Wochenende' /> */}
          <DeathVaccTable />
        </>
      )}

      {display === 'type' && (
        <>
          {/* <UpdateNote updating='Wird um 14 Uhr aktualisiert, ausser am Wochenende' /> */}
          <BrkthruBarChart />
        </>
      )}
    </div>
  )
}
